import { useSelector, useDispatch } from "react-redux";
import { saveSchedule } from "../../stores/schedule/scheduleActions";
import i18n from "../../utils/i18n";


const SaveScheduleButton = ({ url, publish }) => {
  const dispatch = useDispatch();
  const saveStatus = useSelector((state) => state.schedule.schedule.save_status);
  const loading = useSelector((state) => state.member.loading);

  const handleSaveSchedule = (e) => {
    e.preventDefault();
    dispatch(saveSchedule(url, publish));
  };

  const renderButton = () => {
    if (saveStatus === "saving" || loading) {
      return (
        <a href="##" className="btn btn-primary">
          <i className="fa fa-spinner fa-spin"></i>
        </a>
      );
    } else if (saveStatus === "success") {
      return (
        <a href="##" className="btn btn-primary">
          <i className="fa fa-check"></i>
        </a>
      );
    } else if (saveStatus === "error") {
      return (
        <a href="##" className="btn btn-danger">
          <i className="fa fa-times"></i>
        </a>
      );
    } else {
      return (
        <a
          href="##"
          onClick={handleSaveSchedule}
          className="btn btn-primary"
        >
          {i18n.t(publish ? "schedule.save_and_publish" : "schedule.save")}
        </a>
      );
    }
  };

  return <span>{renderButton()}</span>;
};

export default SaveScheduleButton;
